import SuitcaseIcon from '@atlaskit/icon/glyph/suitcase';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { H5, LinkButton } from '@atlassian/mpac-primitives';
import React, { useState } from 'react';
import { TEST_ID } from '../../constants';
import { InfoList, InfoListItem, InfoListItemContent, InfoListItemIcon, ItemDescription, SubSection } from '../styles';
import { IntegrationDetailsModal } from './IntegrationDetailsModal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const IntegrationDetails = props => {
  const {
    enableAppificationChanges
  } = useStatsig();
  const {
    appName,
    appScopes,
    permissionsJustification
  } = props;
  const [open, setOpen] = useState(false);
  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);
  if (!(appScopes !== null && appScopes !== void 0 && appScopes.length)) return null;
  const atlassianAppText = enableAppificationChanges() ? 'app' : 'product';
  return /*#__PURE__*/_jsxs(SubSection, {
    "data-testId": TEST_ID.OVERVIEW_TAB_INTEGRATION_DETAILS,
    children: [/*#__PURE__*/_jsx(H5, {
      as: "h4",
      children: "Integration permissions"
    }), /*#__PURE__*/_jsx(IntegrationDetailsModal, {
      open: open,
      onClose: closeModal,
      appName: appName,
      appScopes: appScopes,
      permissionsJustification: permissionsJustification
    }), /*#__PURE__*/_jsx(InfoList, {
      children: /*#__PURE__*/_jsxs(InfoListItem, {
        children: [/*#__PURE__*/_jsx(InfoListItemIcon, {
          children: /*#__PURE__*/_jsx(SuitcaseIcon, {
            label: "Integration details",
            size: "medium"
          })
        }), /*#__PURE__*/_jsxs(InfoListItemContent, {
          children: [/*#__PURE__*/_jsxs(ItemDescription, {
            children: [appName, " integrates with your Atlassian ", atlassianAppText]
          }), /*#__PURE__*/_jsx(LinkButton, {
            onClick: openModal,
            children: "Check out integration details"
          })]
        })]
      })
    })]
  });
};